import Radium from "radium";
import React from "react";

import { formatDate } from "@common";
import { IDevice } from "@common/models";
import { deviceListItemStyles as styles } from "./device.styles";

export interface IDeviceListItemProps {
  device: IDevice;
  removeDevice: (device: IDevice) => void;
}

class DeviceListItem extends React.Component<IDeviceListItemProps> {
  public render() {
    const lastListItem = {
      ...styles.listItem,
      justifyContent: "flex-end",
      width: "20%",
      flex: "1"
    };

    const { device } = this.props;

    return (
      <div style={styles.row as any} className="row">
        <div style={styles.listItem as any}>{device.userAgent}</div>
        <div style={styles.listItem as any}>{device.deviceId}</div>
        <div style={styles.listItem as any}>
          {device.isApproved
            ? formatDate(device.approvedDate)
            : "Ikke godkjent"}
        </div>
        <div style={lastListItem as any}>
          <div
            onClick={() => this.props.removeDevice(device)}
            style={styles.listLinkStyle}
          >
            Fjern
          </div>
        </div>
      </div>
    );
  }
}

export default Radium(DeviceListItem);
